var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemainingAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.1973,
    width: 3.82428,
    height: 15.2971,
    rx: 1.91214,
    fill: "#006E7E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7598,
    y: 8.05078,
    width: 4.02555,
    height: 17.4441,
    rx: 2.01278,
    fill: "#006E7E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.64648,
    width: 3.82428,
    height: 25.4952,
    rx: 1.91214,
    fill: "#006E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemainingAmount);
export default __webpack_public_path__ + "static/media/remaining_amount.5090251e6c09447e03e9d604d8bc42d4.svg";
export { ForwardRef as ReactComponent };